import axiosClient from '@/api/axiosClient';
import { API_THEMES, API_THEMES_DEFAULT_ITEMS } from '@/config/paths/API_PATH';

const getThemeManagement = async (params) => {
  const response = await axiosClient.get(API_THEMES, { params });
  return response.data;
};

const postThemeManagement = async (params) => {
  const response = await axiosClient.post(API_THEMES, params);
  return response.data;
};

const postThemeManagementFormData = async (params) => {
  const response = await axiosClient.post(API_THEMES, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

const putThemeManagement = async ({ params, id }) => {
  const response = await axiosClient.put(`${API_THEMES}/${id}`, params);
  return response.data;
};

const getThemeManagementId = async ({ id }) => {
  const response = await axiosClient.get(`${API_THEMES}/${id}`);
  return response.data;
};

const getThemeDefaultItems = async () => {
  const response = await axiosClient.get(API_THEMES_DEFAULT_ITEMS);
  return response.data;
};

const postImageItemsThemeManagemen = async ({ params, id, itemCode }) => {
  const response = await axiosClient.post(`${API_THEMES}/${id}/items/${itemCode}/image`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export {
  getThemeManagement,
  getThemeManagementId,
  postThemeManagement,
  putThemeManagement,
  getThemeDefaultItems,
  postImageItemsThemeManagemen,
  postThemeManagementFormData,
};
